export const pt_pt = {
    index: {
        header_1: 'Que ',
        header_2: 'tipo de Armazenamento',
        header_3: ' necessitas?',
        select_option: 'Seleciona uma opção para continuar',
        skip_button_text: 'Saltar - Mostrar todos os preços',
        personal: 'Particular',
        business: 'Empresarial',
        personalText: 'Guarda objetos pessoais, recordações e móveis pequenos',
        businessText:
      'Armazenamento seguro para inventário, documentos e equipamentos empresariais',
    },
    journey_bar: {
        step_1: 'Tipo de Armazenamento',
        step_2: 'Tamanho',
        step_3_a: 'Preços',
        step_3_b: 'Reserva',
        step_4: 'Confirmar',
        step_5: 'Pagamento',
        step_6: 'Resumo',
    },
    unit_listing: {
        header_1: 'Quanto ',
        header_2: 'espaço',
        header_3: ' necessitas?',
        no_units: 'Sem Unidades',
        unit_unavailable_at_move_in:
      'A unidade já não está disponível. Por favor seleciona outra unidade para continuar.',
    },
    book_unit: {
        header_1: 'Seleciona uma ',
        header_2: 'oferta',
        header_3: ' abaixo',
        deals: ' ofertas',
        inclusions: 'O que está incluído',
        click_to_view: 'Clica para ver',
    },
    customise_booking: {
        header_mobile: 'Selecionar Opções',
        upgrade: 'Atualizar',
        booking_details_error: 'Não foi possível guardar os dados da sua reserva. Verifique-os e tente novamente.',
    },
    descriptor: {
        idealFor: 'Ideal Para',
    },
    carousel: {
        smaller: 'Mais pequeno',
        larger: 'Maior',
    },
    stack: {
        inclusions: 'O que está incluído',
    },
    labels: {
        small: 'PEQUENO',
        medium: 'MÉDIO',
        large: 'GRANDE',
        or: 'Ou',
        easiest_access: 'Acesso Mais Fácil',
    },
    time: {
        per_week: 'Por Semana',
        per_month: 'Por Mês',
    },
    sizeSlider: {
        small: 'Pequeno',
        medium: 'Médio',
        large: 'Grande',
    },
    cta: {
        select: 'Selecionar',
        continue: 'Continuar',
        step_3: {
            continue: 'Continuar',
        },
        enquire_now: 'Pedir Informação',
        call_us_now: 'Liga-nos Agora',
        cancel: 'Cancelar',
        close: 'Fechar',
        bigger_unit: 'Precisas de uma unidade maior?',
        email_us: 'Envia-nos um Email',
        call_us: 'Liga-nos',
    },
    unit_card: {
        no_price_chane: 'Sem Alteração de Preço',
        valued_at: 'Avaliado em',
        customise_booking: 'Personalizar Reserva',
        alternative_unit_options: 'Opções Alternativas de Unidade',
        no_units_available: 'Sem unidades disponíveis',
        extra: 'Extra',
        save: 'Economizar',
    },
    coupon_code: {
        title: 'Código Promocional / Cupão',
        apply: 'Aplicar',
        placeholder: 'Introduz aqui o teu código promocional ou cupão',
        success: 'Código promocional aplicado com sucesso',
        error: 'Código promocional expirado ou inválido',
    },
    contact_card: {
        error: 'Erro',
        error_text:
      'Ocorreu um erro ao submeter o formulário. Por favor tenta novamente ou contacta o nosso site se o problema persistir',
        phone: 'Telefone',
        email: 'Email',
        first_name: 'Nome',
        last_name: 'Apelido',
        email_address: 'Endereço de Email',
        move_in_date: 'Data de Entrada',
        phone_number: 'Número de Telefone',
        address: 'Morada',
        postcode: 'Código Postal',
        city: 'Cidade',
        state: 'Distrito',
        reservation: {
            title: 'Reserva',
            subtitle:
        'Quase lá! Só precisamos de mais alguns dados para finalizar a tua reserva.',
            success: 'Reservado!',
            success_detail: 'Obrigado, a tua reserva foi criada com sucesso.',
        },
        quote: {
            title: 'Detalhes do Orçamento',
            subtitle:
        'Quase lá! Só precisamos de mais alguns dados e o teu orçamento personalizado será enviado por email.',
            success: 'Orçamento Enviado!',
            success_detail:
        'Obrigado, o teu orçamento foi enviado para a tua caixa de entrada.',
        },
        showPrices: {
            title: 'Mostrar Preços',
            form_title: 'Mostrar Preços',
            submit_text: 'Mostrar Preços',
            subtitle:
        'Quase lá! Só precisamos de mais alguns detalhes para te fornecer um orçamento personalizado.',
        },
        contactMe: {
            title: 'Pedir Informação',
            submit_text: 'Pedir Informação',
        },
        largerUnit: {
            title: 'Pedir Informação sobre uma Unidade Maior',
            form_title: 'Pedido de Unidade Maior',
            submit_text: 'Enviar Pedido',
            subtitle:
        'Deixa os teus dados e entraremos em contacto sobre uma unidade adequada.',
            success: 'Pedido Enviado!',
            success_detail:
        'Obrigado, recebemos o teu pedido e entraremos em contacto em breve.',
            message:
        'Este cliente procura uma unidade maior do que os tamanhos apresentados.',
            largest_size: 'Maior tamanho apresentado',
        },
    },
    wizard: {
        back: 'Voltar',
        reservation: 'Reserva',
        scheduleMoveIn: 'Agendar entrada',
        finalisingMoveIn: 'A finalizar a tua entrada…',
        moveInPaymentSucceededButFailed: 'O teu pagamento foi recebido, mas não foi possível concluir a tua entrada. Por favor, contacta-nos para que possamos terminar a preparação da tua unidade.',
        moveInProcessingTimeout: 'O teu pagamento foi recebido e a tua entrada ainda está a ser processada. Por favor, contacta-nos caso não seja confirmada em breve.',
        finalisingReservation: 'A finalizar a tua reserva…',
        reservationFeePaymentSucceededButFailed: 'O teu pagamento foi recebido, mas não foi possível concluir a tua reserva. Por favor, contacta-nos para que possamos terminar de garantir a tua unidade.',
        reservationFeeProcessingTimeout: 'O teu pagamento foi recebido e a tua reserva ainda está a ser processada. Por favor, contacta-nos caso não seja confirmada em breve.',
        moveInErrorContactHeading: 'Precisas de ajuda? Por favor, contacta a tua loja:',
        moveInErrorQuoteHeading: 'Por favor, indica os seguintes dados quando entrares em contacto:',
        moveInErrorPhone: 'Telefone: {{phone}}',
        moveInErrorEmail: 'Email: {{email}}',
        moveInErrorName: 'Nome: {{name}}',
        moveInErrorUnit: 'Unidade: {{unit}}',
        copy: 'Esta reserva requer o pagamento de uma taxa. Por favor segue os passos para completar a tua reserva. Durante o processo reservaremos uma unidade para ti e enviaremos um email com os detalhes.',
        selectDate: 'Seleciona a data em que pretendes entrar.',
        next: 'Seguinte',
        confirm_booking: 'Confirmar Reserva',
        payViaFinverse: 'Pagar via Finverse',
        process_paypal: 'Pagar via PayPal',
        termsAndConditionsAgree: 'Concordo com os termos e condições',
        marketingAgree: 'Aceito comunicações de marketing',
        assistanceMovingAgree: 'Preciso de assistência com um camião ou reboque de mudanças',
        dateOfBirth: 'Data de Nascimento',
        otherError:
      'Ocorreu um erro inesperado, por favor atualiza a página e tenta novamente ou contacta o suporte',
        autobill: 'Débito automático no meu cartão para evitar atrasos',
        autobillDetails: {
            title: 'Débito Automático',
            directDebit: 'Débito Direto',
            creditCard: 'Cartão de Crédito',
            bsbNumber: 'Número BSB',
            accountNumber: 'Número de Conta',
            none: 'Nenhum',
            switchToDebit: '',
        },
        personal: 'Particular',
        business: 'Empresarial',
        contactDetails: {
            title: 'Detalhes de Contacto',
            titles: {
                mr: 'Sr.',
                mrs: 'Sra.',
                miss: 'Srta.',
                ms: 'Sra.',
                dr: 'Dr.',
            },
            commercial:
        'Por favor introduz o nome da empresa e o número de registo. Deves estar autorizado a agir em nome da empresa.',
            company: 'Nome da Empresa',
            companyNumber: 'Número de Registo da Empresa',
            licencePlate: 'Número de Matrícula',
        },
        alternateContactDetails: {
            title: 'Detalhes de Contacto Alternativo',
            subtitle:
        'Esta informação permite-nos contactar outra pessoa caso não seja possível contactar-te.',
        },
        accountDetails: {
            title: 'Detalhes da Conta',
            copy: 'Deves ter entre 8 e 20 caracteres, conter pelo menos uma maiúscula, uma minúscula e um número. Esta palavra-passe permitirá aceder e pagar a tua conta online após a entrada.',
            password: 'Palavra-passe Online',
            confirmPassword: 'Confirmar Palavra-passe Online',
        },
        reservationWithFee: {
            orderNumber: 'Número da Encomenda: ',
            confirmationText:
        'Enviámos um email com todos os detalhes da tua encomenda. Lembra-te que podes acompanhar a tua encomenda através desta aplicação.',
        },
        reservationConfirmed: {
            title: 'Reserva Confirmada',
            subtitle: 'Irás receber um email com os detalhes da tua reserva.',
            finaliseBooking: 'Finalizar Reserva Agora',
        },
        findReservation: {
            title: 'Continua a tua mudança',
            subtitle: 'Introduz o teu número de referência para continuar com a tua mudança.',
            inputLabel: 'Número de referência',
            placeholder: 'Número de referência',
            submit: 'Continuar',
            notFoundError: 'Não encontrámos nenhuma reserva com esse número de referência. Verifica-o e tenta novamente.',
        },
        insuranceCoverage: {
            title: 'Cobertura de Seguro',
            subtitle:
        'O seguro não está incluído no valor da renda. Recomendamos vivamente que todos os clientes assegurem os seus bens para a tua tranquilidade.',
            coverage: 'Cobertura',
            for_up_to: 'até ',
            noInsuranceSelected: 'Sem Seguro Selecionado',
            manualEntryLabel: 'Valor declarado dos bens armazenados',
            disclaimer:
        'Ao assinalar esta caixa aceitas e concordas: que a opção de seguro selecionada cobre o valor real de substituição dos bens declarados, aceitas os T&C abaixo e compreendes as inclusões/exclusões da apólice.',
            flatRateInsurance: 'Seguro de Valor Fixo',
            selfInsurance: 'Seguro Próprio',
            usSupply:
        'Seleciona esta opção se pretendes que NÓS forneçamos o seguro.',
            subTitle: 'Seleciona esta opção se VOCÊ fornecer o seguro',
            proofDisclaimer:
        'Nota: terás de carregar o comprovativo de seguro abaixo para concluir a tua reserva',
            fileTypePlease:
        'Por favor carrega um ficheiro jpg, png ou pdf na secção de Comprovativo de Seguro abaixo.',
            pickerText: '',
        },
        addressProof: {
            title: 'Comprovativo de Morada',
            subtitle: 'Carrega documentação que comprove a morada fornecida',
            fileUploadHelpText:
        'Por favor carrega uma foto que comprove a tua morada atual. Exemplos: extratos bancários, de cartão de crédito ou faturas de serviços.',
            uploading: 'A carregar...',
            success: 'Ficheiro carregado com sucesso',
            error: 'Erro ao carregar ficheiro',
        },
        insuranceProof: {
            title: 'Comprovativo de Seguro',
            subtitle:
        'Carrega documentação que comprove o seguro contratado para o valor declarado',
            fileUploadHelpText: 'Uma foto tua tipo passe (rosto e ombros).',
            uploading: 'A carregar...',
            success: 'Ficheiro carregado com sucesso',
            error: 'Erro ao carregar ficheiro',
        },
        boxShop: {
            title: 'Materiais de Mudança e Embalagem',
            outOfStock: 'Esgotado',
            pickUpLocation: 'Local de Levantamento',
            showAll: 'Mostrar Tudo',
            showLess: 'Mostrar Menos',
        },
        pricingTable: {
            title: 'Resumo da Reserva',
            charge: 'Encargo',
            amount: 'Valor',
            discount: 'Desconto',
            initialAmount: 'Valor Inicial',
            subtotal: 'Subtotal',
            tax: 'Imposto',
            total: 'Total',
            including: 'incluindo',
        },
        identityVerification: {
            title: 'Verificação de Identidade',
            driverLicenseDetails: 'Detalhes da Carta de Condução',
            uploadDriverLicense: 'Carta de Condução',
            fileUploadHelpText:
        'Por favor carrega uma foto da FRENTE da tua carta de condução ou passaporte em ficheiro JPG, PNG ou PDF',
            idDocumentNumber: 'Número do Documento de Identificação',
        },
        paymentForm: {
            title: 'Pagamento',
            csvAmexPlaceholder: 'CVC (4 dígitos)*',
            errors: {
                cardHolderInvalid: 'Nome do Titular do Cartão inválido',
                cardNumberInvalid: 'Número do Cartão inválido',
                cardNumberLuhnInvalid: 'Por favor, verifique o número do seu cartão. Parece não ser válido.',
                cardExpiryInvalid: 'Validade do Cartão inválida',
                cardExpiryExpired: 'O seu cartão expirou.',
                cardCsvInvalid: 'CSV do Cartão inválido',
            },
        },
        bookingConfirmation: {
            title: 'Obrigado pela sua reserva',
            subtitle:
        'Enviámos um email com mais detalhes, por favor consulta o email para mais informações.',
            referenceCode: 'O teu código de referência é: ',
            autobillError:
        'A tua entrada foi bem-sucedida, mas houve um problema com os dados de pagamento automático. Por favor contacta o suporte.',
            merchPaymentError:
        'A tua entrada foi bem-sucedida, mas houve um problema com a tua mercadoria. Por favor contacta o suporte.',
            insuranceError:
        'A tua entrada foi bem-sucedida, mas houve um problema ao atribuir o teu seguro. Por favor contacta o suporte.',
            customerSurvey: {
                title: 'Inquérito ao Cliente',
                subtitle:
          'Valorizamos muito o teu feedback e agradecíamos que respondesses a algumas perguntas rápidas abaixo!',
                submit: 'Submeter Inquérito',
            },
            idVerifyButtonText: 'Verificar Identidade',
            idVerifyText:
        'Por favor verifica a tua identidade usando o botão abaixo. Em alternativa, podes fazê-lo mais tarde na aplicação.',
        },
        marketingSurvey: {
            title: 'Inquérito ao Cliente',
            subtitle:
        'Ajuda-nos a melhorar os nossos serviços respondendo às seguintes perguntas:',
            Marketing: 'Onde ouviste falar de nós?',
            MktgDistance: 'Distância da instalação?',
            MktgWhy: 'Porque estás a armazenar?',
            MktgType: 'Qual a opção que melhor te descreve?',
            MktgWhat: 'O que estás a armazenar?',
            MktgReason: 'Qual o motivo para armazenar connosco?',
            submit: 'Submeter Inquérito',
            defaultOption: 'Por favor seleciona uma opção',
        },
        termsAndConditions: 'Termos e Condições',
    },
    error: {
        oops: 'Ups! Algo correu mal',
        subtitle: 'Lamentamos, ocorreu um erro inesperado.',
        general_error:
      'Ocorreu um erro geral, por favor tenta novamente ou contacta o suporte',
        go_back: 'Voltar atrás',
        not_found:
      'A página que procuraste não foi encontrada, por favor verifica se escreveste o endereço corretamente ou se a página foi movida.',
        move_in_error:
      'Ocorreu um problema no processo de entrada, por favor contacta o suporte se o problema persistir.',
    },
    map: {
        map: 'Mapa',
        booking: 'Reserva',
        smaller: 'Mais pequeno',
        bigger: 'Maior',
        select_unit: 'Seleciona uma unidade abaixo',
        booking_card: {
            title: 'DETALHES DA TUA RESERVA',
            deals: 'DESCONTOS & OFERTAS DA INSTALAÇÃO',
            select_a_deal: 'Seleciona uma oferta para aplicar à tua reserva',
            different_unit:
        'Seleciona um tipo ou padrão de unidade diferente abaixo.',
            change_size: 'Alterar Tamanho',
        },
    },
    errors: {
        10000: 'Ocorreu um erro, por favor tenta novamente mais tarde.',
        10001: 'A unidade já está alugada ou já não está disponível.',
        50716: 'Transação Recusada. Falha na Autenticação 3D Secure',
    },
    standardUnitListing: {
        noUnitsAvailable: 'De momento não há unidades disponíveis',
        spaceCalculator: {
            title: 'Calculadora de espaço',
            notSureAboutSizing: 'Não tem a certeza relativamente ao tamanho?',
            needHelpTitle: 'Não tem a certeza de quanto espaço precisa?',
            weCanHelp: 'Nós podemos ajudar.',
            findMeASpace: 'Me encontre uma unidade',
            orCall: 'ou ligue para',
            previousStep: 'Passo Anterior',
            intro: 'Descubra mini-armazéns à sua medida. Não precisa de preencher todos os campos. Preencha os que são relevantes para si.',
            stepOne: 'Passo 1:',
            stepOneTitle: 'Escolha o que precisa',
            stepTwo: 'Passo 2:',
            stepTwoTitle: 'Insira seus detalhes',
            stepTwoHelp: 'Usar o controle deslizante abaixo',
            clickBoxAbove: 'Clique em uma opção acima',
            movingHouse: 'Mudança de casa',
            extraSpace: 'Precisa de mais espaço?',
            vehicleStorage: 'Armazém para vehiculos',
            vehicleStorageUnavailable: 'Armazém para vehiculos (N/A)',
            businessStorage: 'Armazenagem para Empresas',
            customNeeds: 'Ideciso sobre quanto espaço precisa?',
            bedrooms: 'Número de quartos:',
            smallRooms: 'Número de quartos pequenos:',
            largeRooms: 'Número de quartos grandes:',
            garages: 'Número de garagens:',
            rooms: 'Número de quartos:',
            largeItems: 'Número de grandes itens:',
            smallItems: 'Número de pequenos itens:',
            boxes: 'Número de caixas:',
            width: 'Largura ({{sizeSymbol}}):',
            length: 'Comprimento ({{sizeSymbol}}):',
            or: 'OU',
            findUnitSize: 'Encontre soluções de armazenagem',
        },
    },
};
